import React from "react";
import "./footer.css";
import download_icon from "../../assets/downlad_icon.jpg";
import github_icon from "../../assets/github_icon.webp";
import ln_icon from "../../assets/ln_icon.png";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer>
        <div className="container">
          <h1><Link to={"/"} className="link">compressor.
          </Link></h1>
          <div className="footer-details">
            <p>
            Reduce image sizes without quality loss. Free, fast, and secure online image compressor. Optimize your images today!
            </p>

            <ul>
              <li><Link className="link" to={"/about"}>About Us</Link></li>
              <li>Pricing</li>
              <li>Contact Us</li>
            </ul>
          </div>
          <div className="social-links">
         
            
         
            
           
          </div> <hr />
          <p>Developed by @ <a href="http://adsoftwaredevelopment.in/" target="__blank">Avdhesh</a> </p>
        </div>
       
      </footer>
    </>
  );
}

export default Footer;
